module.exports = __webpack_public_path__ + "aaa4ff937803f1e1101848739efb1930.svg";